module.exports = __webpack_public_path__ + "img/bcp-logo.0fe4b190.webp";